var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"hm-button",style:({background: _vm.background, color: _vm.color})},[(_vm.loading)?_c('span',{staticClass:"hm-button__spinner",attrs:{"aria-hidden":"true"}}):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }